<ag-grid-angular
  style="width: auto; height: 160px"
  class="grid ag-theme-alpine grid-detail"
  [gridOptions]="gridOptions">
</ag-grid-angular>
